export const DESIGN_EDITOR_ACTION_PREFIX = 'DESIGN_EDITOR';
export const DESIGN_EDITOR_STORE_NAME = 'editingDesign';
